import { usePage } from '@inertiajs/vue3';
import { markRaw, toRaw } from 'vue';
import { Menu, PropertiesInterface } from '~/types';

const components = {
  text: 'TextMenuItem',
  column: 'ColumnMenuItem',
  'static-url': 'StaticUrlMenuItem',
  'title-menu-item': 'TitleMenuItem',
  'image-menu-item': 'ImageMenuItem',
  'social-icon-collection-menu-item': 'SocialIconCollectionMenuItem',
};

function resolveComponentsForMenuItem(menuItem: Menu.MenuItem) {
  menuItem.component = components[menuItem.type] || null;

  if (menuItem.children.length > 0) {
    menuItem.children = menuItem.children.map((childrenMenuItem) => resolveComponentsForMenuItem(childrenMenuItem));
  }

  return menuItem;
}

export const resolveMenuBySlug = (slug: string): null | Menu.Model => {
  const filteredMenus = usePage<PropertiesInterface>().props.menus.filter((menu) => menu.slug === slug);

  const menu = filteredMenus.length > 0 ? toRaw(filteredMenus[0]) : null;

  if (!menu) {
    return null;
  }

  menu.menuItems = menu.menuItems.map((menuItem) => markRaw(resolveComponentsForMenuItem(menuItem)));

  return markRaw<Menu.Model>(menu);
};

export const resolveMenuById = (id?: number): null | Menu.Model => {
  const filteredMenus = usePage<PropertiesInterface>().props.menus.filter((menu) => menu.id === id);

  const menu = filteredMenus.length > 0 ? toRaw(filteredMenus[0]) : null;

  if (!menu) {
    return null;
  }

  menu.menuItems = menu.menuItems.map((menuItem) => markRaw(resolveComponentsForMenuItem(menuItem)));

  return markRaw<Menu.Model>(menu);
};

export const openSubmenu = (event: Event) => {
  const item = event.target as HTMLElement;
  const parent = item.parentElement;
  const submenu = parent?.querySelector('.submenu');
  const parentWrapper = parent?.parentElement;
  const openedItems = parentWrapper?.querySelectorAll('.has-dropdown.active');

  if (!parent?.contains(submenu as HTMLElement)) {
    return;
  } else {
    openedItems?.forEach((item) => {
      if (item != parent && item.classList.contains('active')) {
        item.classList.remove('active');
        item.querySelector('a')?.setAttribute('aria-expanded', 'false');
      }
    });
    if (parent?.classList.contains('active')) {
      parent?.classList.remove('active');
      item.setAttribute('aria-expanded', 'false');
    } else {
      parent?.classList.add('active');
      item.setAttribute('aria-expanded', 'true');
    }
  }
};

export const closeSubmenu = (parentWrapper: HTMLElement) => {
  const openedItems = parentWrapper?.querySelectorAll('.has-dropdown.active');

  openedItems?.forEach((it) => {
    it.classList.remove('active');
  });
};
